import { IEventsVehicleHistory } from "typings/global";
import { DrawerStatusEnum } from "typings/global.types";

export enum CheckinOriginEnum {
  Unknown = 0,
  Integration = 1,
  Manually = 2,
}

export interface IDocumentsActive {
  id: number;
  documentId?: number;
  type: string;
  value: string;
}

export interface IDrivers {
  name: string;
  cpf: string;
}

export type IItems = {
  id: number;
  carrier: string;
  vehiclePlate: string;
  process: string;
  inboundEventTime: string;
  action: boolean;
  trailersplate: string[];
  documents: string[];
};

export type IItemsCheckin = {
  id: number;
  carrier: string;
  vehiclePlate: string;
  process: string;
  checkinEventTime: string;
  action: boolean;
  trailersplate: string[];
  documents: string[];
  radiusInEventTime: string;
};

export interface ISaleChannel {
  id: number;
  description: string;
}

export interface IRegisterActiveItem {
  carrier: string;
  id: number;
  observation: string;
  trailersPlates: string[];
  vehiclePlate: string;
  processId: number;
  processDescription: string;
  invoices: string[];
  documents: Array<IDocumentsActive>;
  yardRegisterId?: number;
  fromCheckin?: boolean;
  drivers?: IDrivers[];
  saleChannel?: ISaleChannel;
  lenghtOfStay: string;
  checkinOrigin: CheckinOriginEnum;
  isCheckin: boolean;
  hasActiveTag: boolean;
  canEditVehiclePlate?: boolean;
  truckBodyType: number;
  trailerType?: number;
}

export interface IEntryPermissionActive {
  verified: boolean;
  driver: {
    name: string;
    qualification: number;
    photoBase64: string;
    reason: string;
    isFound: boolean;
  };
  vehicle: {
    plate: string;
    description: string;
    qualification: number;
    photoBase64: string;
    reason: string;
    isFound: boolean;
  };
}

export interface IVehicleProfileByPlate {
  trailerType?: number;
  saleChannelId?: number;
  hasCheckin?: boolean;
}

export interface IRegisterCheckinItem {
  carrier: string;
  id: number;
  observation: string;
  trailersPlates: string[];
  vehiclePlate: string;
  processId: number;
  processDescription: string;
  invoices: string[];
  documents: Array<IDocumentsActive>;
  yardRegisterId?: number;
  fromCheckin?: boolean;
  drivers?: IDrivers[];
  saleChannel?: ISaleChannel;
  saleChannelDescription?: string;
  checkinOrigin: CheckinOriginEnum;
  lenghtOfStay: string;
  isCheckin: boolean;
  canEditVehiclePlate?: boolean;
  trailerType?: number;
}

export interface IFilterRegisterActive {
  itemsByPage: number;
  pageIndex: number;
}

export enum IDocumentType {
  IdentificationDocument = 0,
  DriverLicense = 1,
  CpfRequired = 2,
  CnhRequired = 3,
}

export enum IStepEntryPermissionStatus {
  CheckDriverAndVehicle = 0,
  LoadingCheckDriverAndVehicle = 1,
  VerifiedDriverAndVehicle = 2,
  NotFoundDriverAndVehicle = 3,
  RetryCheckDriverAndVehicle = 4,
}

export enum PlateFormatType {
  BRAZIL_MERCOSUR = 0,
  CUSTOM = 1,
  MEXICO = 2,
}

export enum TrailerType {
  BOX_TRAILER = 0,
  CURTAINSIDER = 1,
  FLATBED = 2,
  LIGHTWEIGHT_CURTAINSIDER = 3,
  BULK_TRAILER = 4,
  TANKER = 5,
  OTHER = 6,
}

export enum FleetType {
  DedicatedFleet = 1,
  Spot = 2,
  Resale = 3,
  Collaborative = 4,
  AS = 5,
  Insumo = 6,
  Cmove = 7,
  InsumoLog = 8,
  Others = 9,
  T4 = 10,
}

export interface ILobbyState {
  isLoading: boolean;
  drawerIsLoading: boolean;
  visibleDrawerInbound: boolean;
  visibleDrawerOutbound: boolean;
  visibleDrawerViewRegister: boolean;
  visibleDrawerViewMode: DrawerStatusEnum;
  visibleDrawerCheckinRegister: boolean;
  visibleModalVehicleAction: boolean;
  registerActive?: IRegisterActiveItem;
  processActive: number;
  saleChannelActive?: number;
  outboundProcessActive: number;
  checkinRegisterActive?: IRegisterCheckinItem;
  checkinRegisterExisting?: IRegisterCheckinItem;
  vehicleProfileByPlate?: IVehicleProfileByPlate | null;
  formViewOrEditModified: boolean;
  salesChannelList: Array<ISaleChannelData>;
  inboundProcessesList: Array<IProcessesData>;
  outboundProcessesList: Array<IProcessesData>;
  documentsList: Array<IDocumentsData>;
  searchFilter?: string;
  disabledButton: boolean;
  disabledButtonSaveVehicle: boolean;
  items?: Array<IItems>;
  totalItems: number;
  itemsCheckins?: Array<IItemsCheckin>;
  totalItemsCheckins: number;
  filterActive: IFilterRegisterActive;
  filterCheckin: IFilterRegisterActive;
  hasCheckin: boolean;
  hasSaleChannel: boolean;
  hasAttendance: boolean;
  hasScheduling: boolean;
  hasEntryPermission: boolean;
  documentType: IDocumentType;
  allowRequestDockEntryAction: boolean;
  allowRequestVehicleInboundAction: boolean;
  hasFinishOperationAction: boolean;
  hasRfidReading: boolean;
  allowRequestVehicleEntryAuthorizationAction: boolean;
  hasConfigurationLoaded: boolean;
  vehicleEntryAuthorizationRegisterActive?: Array<IEventsVehicleHistory>;
  visibleDrawerVehicleEntryAuthorization: boolean;
  isLoadingInboundActive: boolean;
  isLoadingInboundCheckin: boolean;
  stepEntryPermissionStatus: IStepEntryPermissionStatus;
  isLoadingEntryPermission: boolean;
  entryPermissionActive: IEntryPermissionActive;
  plateFormatType: PlateFormatType;
}

export interface IProcessesData {
  correlationId: string;
  description: string;
  eventType: string;
  processId: number;
}

export interface ISaleChannelData {
  id: number;
  description: string;
}

export interface IDocumentsData {
  id: number;
  description: string;
  required: number;
  maskRules: {
    allowLetters: boolean;
    allowNumbers: boolean;
    allowSpecialCharacters: boolean;
    minCharacters: number;
    maxCharacters: number;
  };
}

export interface IReportState {
  processesList: IProcessesData;
}
export const processesData = [
  {
    correlationId: null,
    processId: null,
    description: "",
    eventType: "",
  },
];

export const entryPermissionActive = {
  verified: false,
  driver: {
    name: null,
    qualification: null,
    photoBase64: null,
    reason: null,
    isFound: false,
  },
  vehicle: {
    plate: null,
    description: null,
    qualification: null,
    photoBase64: null,
    reason: null,
    isFound: false,
  },
};

export const salesChannelData = [
  {
    id: null,
    description: "",
  },
];
const processesState = processesData;
const salesChannelState = salesChannelData;

export const documentData = [];
const documentsState = documentData;

export const defaultState: ILobbyState = {
  isLoading: false,
  isLoadingEntryPermission: false,
  drawerIsLoading: false,
  isLoadingInboundActive: false,
  isLoadingInboundCheckin: false,
  visibleDrawerInbound: false,
  visibleDrawerOutbound: false,
  visibleDrawerViewRegister: false,
  visibleDrawerCheckinRegister: false,
  visibleModalVehicleAction: false,
  entryPermissionActive: entryPermissionActive,
  registerActive: null,
  checkinRegisterActive: null,
  saleChannelActive: null,
  processActive: null,
  outboundProcessActive: null,
  visibleDrawerViewMode: DrawerStatusEnum.View,
  formViewOrEditModified: false,
  salesChannelList: salesChannelState,
  inboundProcessesList: processesState,
  outboundProcessesList: processesState,
  documentsList: documentsState,
  searchFilter: "",
  filterActive: {
    itemsByPage: 10,
    pageIndex: 1,
  },
  filterCheckin: {
    itemsByPage: 10,
    pageIndex: 1,
  },
  disabledButton: false,
  disabledButtonSaveVehicle: false,
  items: [],
  totalItems: 0,
  itemsCheckins: [],
  totalItemsCheckins: 0,
  hasCheckin: false,
  hasEntryPermission: false,
  plateFormatType: 0,
  stepEntryPermissionStatus: 0,
  documentType: IDocumentType.IdentificationDocument,
  hasAttendance: false,
  hasRfidReading: false,
  allowRequestDockEntryAction: false,
  allowRequestVehicleInboundAction: false,
  hasScheduling: false,
  hasFinishOperationAction: false,
  hasSaleChannel: false,
  allowRequestVehicleEntryAuthorizationAction: false,
  hasConfigurationLoaded: false,
  checkinRegisterExisting: null,
  vehicleProfileByPlate: null,
  vehicleEntryAuthorizationRegisterActive: [],
  visibleDrawerVehicleEntryAuthorization: false,
};
